import { render, staticRenderFns } from "./AttributeTree.vue?vue&type=template&id=50eb1289"
import script from "./AttributeTree.vue?vue&type=script&lang=js"
export * from "./AttributeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports